__turbopack_context__.v({
  "component": "BannerServiceCheckSingleLine-module__W1trvG__component",
  "component__body": "BannerServiceCheckSingleLine-module__W1trvG__component__body",
  "component__copy": "BannerServiceCheckSingleLine-module__W1trvG__component__copy",
  "component__formWrapper": "BannerServiceCheckSingleLine-module__W1trvG__component__formWrapper",
  "hide-for-large": "BannerServiceCheckSingleLine-module__W1trvG__hide-for-large",
  "hide-for-large-only": "BannerServiceCheckSingleLine-module__W1trvG__hide-for-large-only",
  "hide-for-medium": "BannerServiceCheckSingleLine-module__W1trvG__hide-for-medium",
  "hide-for-medium-only": "BannerServiceCheckSingleLine-module__W1trvG__hide-for-medium-only",
  "hide-for-small-only": "BannerServiceCheckSingleLine-module__W1trvG__hide-for-small-only",
  "show-for-large": "BannerServiceCheckSingleLine-module__W1trvG__show-for-large",
  "show-for-large-only": "BannerServiceCheckSingleLine-module__W1trvG__show-for-large-only",
  "show-for-medium": "BannerServiceCheckSingleLine-module__W1trvG__show-for-medium",
  "show-for-medium-only": "BannerServiceCheckSingleLine-module__W1trvG__show-for-medium-only",
  "show-for-small-only": "BannerServiceCheckSingleLine-module__W1trvG__show-for-small-only",
  "u-color-black": "BannerServiceCheckSingleLine-module__W1trvG__u-color-black",
  "u-color-blue": "BannerServiceCheckSingleLine-module__W1trvG__u-color-blue",
  "u-color-midnight": "BannerServiceCheckSingleLine-module__W1trvG__u-color-midnight",
  "u-color-primary-dark": "BannerServiceCheckSingleLine-module__W1trvG__u-color-primary-dark",
  "u-color-red": "BannerServiceCheckSingleLine-module__W1trvG__u-color-red",
  "u-color-white": "BannerServiceCheckSingleLine-module__W1trvG__u-color-white",
  "u-theme-black": "BannerServiceCheckSingleLine-module__W1trvG__u-theme-black",
  "u-theme-blue": "BannerServiceCheckSingleLine-module__W1trvG__u-theme-blue",
  "u-theme-dark": "BannerServiceCheckSingleLine-module__W1trvG__u-theme-dark",
  "u-theme-light": "BannerServiceCheckSingleLine-module__W1trvG__u-theme-light",
  "u-theme-red": "BannerServiceCheckSingleLine-module__W1trvG__u-theme-red",
  "u-theme-white": "BannerServiceCheckSingleLine-module__W1trvG__u-theme-white",
});
